import React from "react";
import { useTranslation } from "react-i18next";
import PageSection from "components/PageSection";
import { Body2, Body3, Small, Title2Alt } from "components/Typography";

const OFFER_KEYS = ["salary", "flexibility", "equity", "autonomy"];

const WhatWeOffer = () => {
    const { t } = useTranslation("careers");
    return (
        <PageSection
            className="relative z-10 bg-white"
            containerClass="flex flex-col items-center gap-24 py-16 md:pb-24 lg:py-32"
        >
            <div className="text-center lg:w-1/2">
                <Body2 className="fade-in-scroll uppercase text-secondary mb-4">{t("offer.eyebrow")}</Body2>
                <Title2Alt className="fade-in-scroll">{t("offer.title")}</Title2Alt>
            </div>
            <div className="flex flex-col lg:flex-row w-full gap-16">
                {OFFER_KEYS.map((key) => (
                    <div key={key} className="fade-in-scroll lg:w-1/4">
                        <Body3 className="mb-4" style={{ fontWeight: 600 }}>
                            {t(`offer.items.${key}.title`)}
                        </Body3>
                        <Small>{t(`offer.items.${key}.body`)}</Small>
                    </div>
                ))}
            </div>
        </PageSection>
    );
};

export default WhatWeOffer;
